import { createSlice } from '@reduxjs/toolkit';
import { keyById } from '@mews/fp';
import { fetchPromotedServicesSucceeded } from '../promotedServices/reducers';

const initialState = {};

const promotedServiceCategoriesSlice = createSlice({
    name: 'promotedServiceCategories',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchPromotedServicesSucceeded, (state, { payload: { resourceCategories } }) => ({
            ...state,
            ...keyById(resourceCategories),
        }));
    },
});

export const { reducer: promotedServiceCategoriesReducer } = promotedServiceCategoriesSlice;
